const RecipientManagerConstants = {
  RECIPIENT_MANAGER_ADD_RECIPIENTS_TAB_SHOW: 'RECIPIENT_MANAGER_ADD_RECIPIENTS_TAB_SHOW',
  RECIPIENT_MANAGER_PUBLIC_LINK_TAB_SHOW: 'RECIPIENT_MANAGER_PUBLIC_LINK_TAB_SHOW',
  RECIPIENT_MANAGER_CUSTOM_TEMPLATE_SHARE_REQUEST: 'RECIPIENT_MANAGER_CUSTOM_TEMPLATE_SHARE_REQUEST',
  RECIPIENT_MANAGER_CUSTOM_TEMPLATE_SHARE_SUCCESS: 'RECIPIENT_MANAGER_CUSTOM_TEMPLATE_SHARE_SUCCESS',
  RECIPIENT_MANAGER_CUSTOM_TEMPLATE_SHARE_FAILURE: 'RECIPIENT_MANAGER_CUSTOM_TEMPLATE_SHARE_FAILURE',
  RECIPIENT_MANAGER_PUBLIC_LINK_UPDATE: 'RECIPIENT_MANAGER_PUBLIC_LINK_UPDATE',
  RECIPIENT_MANAGER_PUBLIC_LINK_ERROR: 'RECIPIENT_MANAGER_PUBLIC_LINK_ERROR',
};

export default RecipientManagerConstants;



// WEBPACK FOOTER //
// ./src-react/SelfServePostBuilderSidePanel/RecipientManager/RecipientManagerConstants.jsx